import styled, { keyframes } from "styled-components";
import { Grid, SecondaryMenu, ArrowScroll, Logo } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { HeadingStyled } from "../../../styles/shared-styles";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const LayoutStyled = styled.section`
  top: 0;
  position: relative;
  will-change: transform;
  transform: ${props => `translateY(${props.position}px)`};
  transition: transform 0.2s linear;
  &::after {
    opacity: 0;
  }
`;

export const LayoutRightStyled = styled.section`
  width: 100%;
  margin-top: 3rem;
  height: 100vh;
  top: 0;
  position: relative;
  will-change: transform;
  transform: ${props => `translateY(${props.position}px)`};
  transition: transform 0.2s linear;
  &::after {
    opacity: 0;
  }
`;
export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  top: -${props => props.theme.spacing.large};
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s linear;
  will-change: opacity;
  display: ${props => (props.isVisible ? "block" : "none")};
`;

export const FullCatalogPageStyled = styled.section`
  height: 100%;
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: ${props =>
      props.background &&
      `url(${props.background}) ${
        props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? `19vw` : `-6vw`
      } 0 / contain no-repeat`};
    transition: opacity 0.2s linear;
    will-change: opacity;
    opacity: ${props => (props.background ? 1 : 0)};
  }
`;

export const BlockStyled = styled.div`
  & {
    ${props => (props.isTabExits ? "width: 78%" : "width: 100%")};
  }
`;

export const BlockStyledTabs = styled.div`
  & nav {
    // margin-right: 3rem;
    ${props => (props.isTabExits ? "margin-right: 0rem" : "margin-right: 0rem")}
    ${props =>
      props.isTabExits
        ? props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT
          ? "margin-left: 2rem"
          : "margin-right: 2rem"
        : props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT
        ? "margin-left: 0rem"
        : "margin-right: 0rem"}
  }
  & nav ul li {
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

export const GridStyled = styled(Grid)`
  display: block;
  position: absolute;
  margin-${props =>
    props.isTabExits && (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  `calc(${props.theme.components.carousel.slideMargin.default} * ${!props.userLogged ? 8 : 2})`};
  & .ReactVirtualized__Grid__innerScrollContainer  .cropped {
    opacity: 0 !important;
  }
  & .Styled__ImageContainerStyled-t5q7es-1 img{
    width: auto;
    height: 100%;
  }
  .focused .selected svg{
    fill: ${props => `${props.theme.components.image.overlay.icon.focusColor} !important`};
  }
  & .selected span{
    opacity:1 !important;
  }
  
  & .ReactVirtualized__Grid__innerScrollContainer {
     overflow:visible !important;
  }
  & .Styled__ImageContainerStyled-t5q7es-1 {
    position : absolute;
    width:100%;
    display: flex;
    justify-content: center;
    // border: 4px solid rgba(100,105,121,0.5) !important;
    border-radius: 1rem;
    border-radius: 0.9rem !important;

  }

  & .focused [class*="ImageContainer"], .focused [class*="ImageContainer"]::before, .ReactVirtualized__Grid.focused .selected [class*="ImageContainer"]::before {
    border-radius: ${props => props.theme.components.image.fallback.borderRadius};
  }

  & .ReactVirtualized__Grid.focused .selected [class*="ImageContainer"]::before {
    background-color: rgba(8,33,37,0.8);
    // box-shadow: 0 22px 34px 0 rgba(0,0,0,0.5);
  }
  .ReactVirtualized__Grid.focused .dcGTAY.selected [class*="ImageContainer"] > img {
    position: relative;
    z-index: 60;
    display:flex;
  }
  .icons_style {
    z-index: 51;
  }

  & .kkHuwl {
    // margin: 1.0416rem;
  }
  & .kkHuwl.selected {
    transform: scale(1.1);
    ${props =>
      props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? "margin-left: 0.677rem" : "margin-right: 0.677rem"};
  }
`;

export const SecondaryMenuStyled = styled(SecondaryMenu)`
  &&& {
    left: auto;
    right:0;
  }
  ${props =>
    `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: -${props.theme.spacing.xsmall}`};
    li {
      border: 2px solid rgba(255,255,255, 0)
    }
    li.selected {
      background: rgba(0,0,0,0.3);
      border: 2px solid ${props => props.theme.color.grey};
    }
    li.focused {
      background: ${props => props.theme.color.primary};
      border: 2px solid ${props => props.theme.color.primary};
    }
    & .llNCVI {
      padding: 0.78rem 1.66rem;
      margin-bottom: 1.1979rem;
    }
    nav {
      left: auto;
      right: 0;
    }
  }
`;

export const TextNoFound = styled.div`
  color: #f1f1f1;
  font-size: 1.5rem;
  margin-bottom: 0.8rem;
  letter-spacing: 0.038rem;
  line-height: 1.5;
  position: relative;
  margin-top: 7rem;
  text-align: center;
`;

export const HeadingTitleStyled = styled(HeadingStyled)`
  &&& {
    margin-left: 1rem;
    font-size: 2.5rem;
    ${props =>
      props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? "padding-left:1.66rem" : "padding-right:1.66rem"};
    font-weight: 300;
  }
`;

export const ContainerWrapper = styled.div`
  width: 112.75rem;
`;

export const LayoutLeftStyled = styled.div``;

export const LineSeparator = styled.div`
  position: absolute;
  border-right: 2px solid ${props => props.theme.color.greyLight};
  top: 15vh;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: 24rem`};
  height: 69vh;
  opacity: 0.2;
`;
